'use-strict'

import only from '../../../utils/functions/only'

export default {
    selected: '',
    all: []
}

export const model = (entity) => only(entity, ['id','team','captain', 'bonusPoints', 'bonusPointsNotes'])